import type { ReactNode } from "react";

import type {
  HeroV2CtaType,
  HeroV2LoyaltyContent,
  HeroV2LoyaltyCtaType,
} from "@jti/ui/components/HeroV2/types/HeroV2Types";

export type ConvertHeroDataResult = {
  title?: ReactNode;
  text?: string;
  ctas: HeroV2CtaType[];
};

export type ConvertHeroDataInput = Pick<
  HeroV2LoyaltyContent,
  "restrictedTitle" | "restrictedText" | "restrictedContent" | "cta" | "titleLogged" | "textLogged"
> & {
  isRestricted: boolean;
};

function isStandardCta(item: HeroV2LoyaltyCtaType): item is HeroV2CtaType {
  return item.additionalBehavior !== "onlyForRestrictedUsers";
}

export function convertHeroData({
  isRestricted,
  titleLogged,
  textLogged,
  cta = [],
  restrictedContent,
  restrictedTitle,
  restrictedText,
}: ConvertHeroDataInput): ConvertHeroDataResult {
  const finalCtas: HeroV2CtaType[] = cta.reduce<HeroV2CtaType[]>((acc, item) => {
    if (isRestricted && restrictedContent) {
      switch (item.additionalBehavior) {
        case "onlyForLoggedIn":
          break;
        case "onlyForRestrictedUsers":
          acc.push({ ...item, additionalBehavior: "onlyForLoggedIn" });
          break;
        default:
          if (isStandardCta(item)) {
            acc.push(item);
          }
      }
    } else if (item.additionalBehavior !== "onlyForRestrictedUsers") {
      if (isStandardCta(item)) {
        acc.push(item);
      }
    }
    return acc;
  }, []);

  const useRestricted = isRestricted && restrictedContent;
  const title = useRestricted ? restrictedTitle : titleLogged;
  const text = useRestricted ? restrictedText : textLogged;

  return { title, text, ctas: finalCtas };
}
